import { IComponent } from './component';
import { IEntity, IEquatable } from './entity';
import { ILocalizable } from './localized';
import { IMedia } from './media';
import { IMeta } from './meta';
import { IPageUnresolvedRelation } from './page';

export type ICategory = IEntity & {
  category?: IEquatable | ICategory;
  id: IEquatable;
  media?: IMedia;
  order?: number;
  slug: ILocalizable;
  title: ILocalizable;
  isHidden?: boolean;
};

export type ICategoryItem = ICategory & {
  items: ICategory[];
};

export type ICategorized = IEntity & {
  // required
  category: IEquatable | ICategory;
  slug: ILocalizable;
  title: ILocalizable;
  // optional
  _status?: string;
  abstract?: string;
  components?: IComponent[],
  createdAt?: Date;
  description?: string;
  isDefault?: boolean;
  isProtected?: boolean;
  markets?: string[];
  media?: IMedia;
  meta?: IMeta;
  order?: number;
  publicRedirect?: IEquatable | IEntity | IPageUnresolvedRelation;
  template?: string;
  updatedAt?: Date;
  useSplat?: boolean;
};
